// src/pages/SuperAdminLogin.jsx - FIXED version
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSuperAdminAuth } from '../contexts/SuperAdminAuthContext';
import { loginSuperAdmin } from '../api/superAdminService';

function SuperAdminLogin() {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  const { currentSuperAdmin, isSuperAdmin, loading: authLoading } = useSuperAdminAuth();

  const { email, password } = formData;

  // Check if already authenticated
  useEffect(() => {
    console.log('SuperAdminLogin - Auth check:', {
      currentSuperAdmin: !!currentSuperAdmin,
      isSuperAdmin,
      authLoading
    });

    if (!authLoading && currentSuperAdmin && isSuperAdmin) {
      console.log('SuperAdminLogin - Already authenticated, redirecting to dashboard');
      navigate('/superadmin/dashboard', { replace: true });
    }
  }, [currentSuperAdmin, isSuperAdmin, authLoading, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      console.log('Attempting SuperAdmin login...');
      await loginSuperAdmin(email, password);
      console.log('Login successful, waiting for auth state update...');
      
      // Don't navigate immediately - let the auth context handle it
      // The useEffect above will handle navigation when auth state updates
      
    } catch (err) {
      console.error('Login error:', err);
      setError('Invalid SuperAdmin credentials. Please check your email and password.');
    } finally {
      setLoading(false);
    }
  };

  // Show loading if auth is being checked
  if (authLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #E64C31',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <p>Checking authentication...</p>
        </div>
      </div>
    );
  }

  // Simple inline styles to ensure visibility
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    fontFamily: 'Arial, sans-serif',
    padding: '20px'
  };

  const cardStyle = {
    width: '6in', // 6 inches width as requested
    maxWidth: '90%', // Responsive on smaller screens
    padding: '40px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    margin: '0 auto' // Ensures horizontal centering
  };

  const buttonStyle = {
    backgroundColor: loading ? '#cccccc' : '#E64C31',
    color: 'white',
    border: 'none',
    padding: '12px 20px',
    borderRadius: '6px',
    width: '100%',
    fontSize: '16px',
    cursor: loading ? 'not-allowed' : 'pointer'
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h1 style={{
          textAlign: 'center',
          color: '#E64C31',
          marginBottom: '10px',
          fontFamily: "'Fraunces', serif",
          fontSize: '30px',
          fontWeight: 'bold'
        }}>
          BespokeBeauty
        </h1>
        <h2 style={{ textAlign: 'center', marginBottom: '5px' }}>
          SuperAdmin Login
        </h2>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '20px' }}>
          Developer Access Portal
        </p>
        
        {error && (
          <div style={{ 
            backgroundColor: '#ffebee', 
            color: '#d32f2f', 
            padding: '10px', 
            marginBottom: '20px', 
            borderRadius: '4px',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={email}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="superadmin@yourcompany.com"
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '14px',
                boxSizing: 'border-box',
                opacity: loading ? 0.6 : 1
              }}
            />
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
              Password
            </label>
            <input
              type="password"
              name="password"
              value={password}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="Enter your password"
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '14px',
                boxSizing: 'border-box',
                opacity: loading ? 0.6 : 1
              }}
            />
          </div>
          
          <button 
            type="submit" 
            style={buttonStyle}
            disabled={loading}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>
        
        <div style={{ 
          marginTop: '25px', 
          textAlign: 'center', 
          fontSize: '12px', 
          color: '#666' 
        }}>
          <p>This is a restricted developer portal for managing salon client configurations.</p>
        </div>
      </div>
    </div>
  );
}

export default SuperAdminLogin;
